import { useQueryClient } from "@tanstack/react-query"
import { getAffiliationLabel } from "pages/School/Affiliations/hooks/getAffiliationLabel"
import { useContext, useMemo } from "react"
import { useSelector } from "react-redux"
import { CreateAssessmentsContext } from "../CreateAssessmentsContext"
import { isEmpty, map } from "lodash"
import { secretStorage } from "config"
import qc from "keys/queryClient"
import { affiliationGroups } from "keys"

const useTestTakersHeaderFilters = () => {
    const queryClient = useQueryClient()

    const { resetSelection, testTakerFilters, testTakersOptions } = useContext(CreateAssessmentsContext)
    const { roleIndex } = useSelector(state => state.user)
    const { brokenDisplay } = useSelector(state => state.general)

    const isSchoolGroup = testTakerFilters?.affiliation?.group_name == affiliationGroups.schools

    const cities = queryClient.getQueryData([qc.cities])

    const user = secretStorage.getItem("user")
    const { user_data } = user || {}
    const { affiliations, grades, classes, affiliation_groups } = user_data?.[roleIndex]?.user_data || {}

    const mapGroups = map(testTakerFilters?.groups, "id")
    const filterAffiliations = isEmpty(testTakerFilters?.group) ?
        affiliations :
        affiliations?.filter(aff => aff.group == testTakerFilters?.group?.id)

    const mapGrades = map(testTakerFilters?.grades, "id")
    const mapAffiliations = map(testTakerFilters?.affiliations, "id")

    const filterClasses =
        isEmpty(testTakerFilters?.grades) && isEmpty(testTakerFilters?.affiliation) ?
            [] :
            classes.filter(cl => mapGrades.includes(cl.grade) && mapAffiliations.includes(cl.affiliation))

    // const mapClasses = map(testTakerFilters?.school_classes, "id")
    // const filterTestTakers =
    //     isEmpty(testTakerFilters?.school_classes) ?
    //         testTakers :
    //         testTakers.filter(te => mapClasses.includes(te.school_class))

    const generalFilters = useMemo(() => [
        {
            id: 1,
            placeholder: "סוג לקוח",
            options: affiliation_groups,
            name: "group",
            component: "autoComplete",
        },
        {
            id: 2,
            placeholder: "שם הלקוח*",
            options: filterAffiliations,
            name: "affiliation",
            getTooltip: (opt) => getAffiliationLabel(opt),
            component: "autoComplete",
            getOptionLabel: (opt) => getAffiliationLabel(opt),
            onChange: resetSelection
        }
    ], [testTakersOptions, filterClasses, filterAffiliations, cities, brokenDisplay, affiliations, affiliation_groups, grades, grades, classes])

    const schoolFilters = useMemo(() => [
        {
            id: 3,
            placeholder: "שכבות",
            name: "grades",
            component: "autoComplete",
            options: grades,
            multiple: true,
        },
        {
            id: 4,
            placeholder: "כיתות",
            options: filterClasses,
            multiple: true,
            name: "school_classes",
            component: "autoComplete",
        },
        {
            id: 5,
            placeholder: "תלמידים",
            options: testTakersOptions.data || [],
            getTooltip: (opt) => opt.school_class,
            name: "test_takers",
            component: "autoComplete",
            multiple: true,
            width: 200,
            optionsLimit: 20,
            brokenDisplay: brokenDisplay,
            showBlurred: brokenDisplay && true,
        }
    ], [testTakersOptions, filterClasses, filterAffiliations, cities, brokenDisplay, affiliations, affiliation_groups, grades, grades, classes])


    return isSchoolGroup ? [...generalFilters, ...schoolFilters] : generalFilters

}

export default useTestTakersHeaderFilters